import { useEffect, useRef, useState } from "react";

function greeting(): string {
  const h = new Date().getHours();
  if (h < 5) return "  the witching hour, then.";
  if (h < 7) return "  a dawn visitor.";
  if (h < 12) return "  good morning.";
  if (h < 17) return "  afternoon.";
  if (h < 22) return "  evening.";
  return "  still up?";
}

const BOOT_LINES: { text: string; delay: number }[] = [
  { text: "BrainSteam Labs BIOS v0.1.0 (build 2026.04)", delay: 60 },
  { text: "Booting from /dev/ideas ...", delay: 140 },
  { text: "  [ok] mounting cortex                       ", delay: 200 },
  { text: "  [ok] loading semantic index    (29 nodes)  ", delay: 200 },
  { text: "  [ok] loading procedural memory (47 routines)", delay: 200 },
  { text: "  [ok] connecting to shipmate channel        ", delay: 220 },
  { text: "  [ok] pulling project graph                 ", delay: 220 },
  { text: "  [..] aligning curiosity vector             ", delay: 320 },
  { text: "  [ok] aligning curiosity vector             ", delay: 60 },
  { text: "", delay: 80 },
  { text: greeting(), delay: 240 },
  { text: "", delay: 200 },
];

interface Props {
  onDone: () => void;
}

export default function Boot({ onDone }: Props) {
  const [lines, setLines] = useState<string[]>([]);
  const timeoutRef = useRef<number[]>([]);

  useEffect(() => {
    let cumulative = 0;
    BOOT_LINES.forEach((line, idx) => {
      cumulative += line.delay;
      const t = window.setTimeout(() => {
        setLines((prev) => {
          // overwrite previous "[..]" line if this is its [ok] replacement
          if (line.text.startsWith("  [ok]") && prev.length > 0) {
            const last = prev[prev.length - 1];
            if (last.startsWith("  [..]") && last.slice(7) === line.text.slice(7)) {
              return [...prev.slice(0, -1), line.text];
            }
          }
          return [...prev, line.text];
        });
        if (idx === BOOT_LINES.length - 1) {
          const done = window.setTimeout(onDone, 400);
          timeoutRef.current.push(done);
        }
      }, cumulative);
      timeoutRef.current.push(t);
    });
    return () => {
      timeoutRef.current.forEach(clearTimeout);
    };
  }, [onDone]);

  return (
    <pre
      style={{
        margin: 0,
        padding: "2rem 2.5rem",
        height: "100%",
        background: "var(--bg)",
        color: "var(--term-green)",
        fontFamily: "var(--mono)",
        fontSize: "0.875rem",
        lineHeight: 1.55,
        whiteSpace: "pre",
        textShadow: "0 0 8px rgba(74, 222, 128, 0.35)",
      }}
    >
      {lines.join("\n")}
      <span className="boot-cursor">█</span>
      <style>{`
        .boot-cursor {
          display: inline-block;
          margin-left: 2px;
          animation: blink 1s steps(2, end) infinite;
        }
        @keyframes blink {
          to { visibility: hidden; }
        }
      `}</style>
    </pre>
  );
}
